<template>
  <div>
    
    <h2 is="sui-header">My clients</h2>
    <sui-card-group>
      
        <sui-card v-for="client in clients" v-bind:key="client.clientId" v-on:click="selectClient(client.clientId)" :class="client.clientId==clientId ? 'green' : ''">
          <sui-card-content>
            <sui-card-header>{{ client.clientName }}</sui-card-header>
            <sui-card-meta>{{ client.role }}</sui-card-meta>
          </sui-card-content>
      </sui-card>
      
      <sui-card v-on:click="createClient()">
          <sui-card-content>
            <sui-card-header>New client</sui-card-header>
            
          </sui-card-content>
          <sui-button attached="bottom">
          <sui-icon name="add" /> Create
        </sui-button>
      </sui-card>
    </sui-card-group>
    
  </div>
</template>

<script>
import DziService from '@/DziService'

export default {
  name: 'ClientSelect',
  data () {
        return {
            clients: [],
            error: null
        }
    },  
    computed: {
        clientId() { return this.$store.state.clientId },
        signedIn() { return this.$store.state.signedIn },
    },
    mounted() {
        this.loadClients();    
    },
    
    
    methods: {
        selectClient(clientId)
        {
            
            let clientName = this.clients.find(client => client.clientId == clientId).clientName;
            this.$store.commit('setClient', {'clientId': clientId, 'clientName': clientName});
            
        },
        createClient()
        {
          this.$router.push({name:'client_create'})  
        },
        
        async loadClients () {

            
            DziService.getClients()
            .then(response => {
              if (response.data && response.data.error)
              {
                  this.$store.commit('setError', 'Can\'t load clients: ' + response.data.error);
              }
              else 
              {
                  this.clients = response.data;
              }
            })
            .catch(err => {
              this.$store.commit('setError', 'Can\'t load clients: ' + err);
            })
            
            


            
                
        },
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
